<tui-avatar
  [src]="photoSrc | safe: 'resourceUrl' | tuiFallbackSrc: (text || '' | tuiInitials) | async"
  [style.background]="!photoSrc && text ? (text | tuiAutoColor) : ('' | tuiAutoColor)"
  class="image"
  [size]="size"
  [ngStyle]="{ width, height, 'border-radius': borderRadius, cursor: photoSrc ? 'pointer' : 'default' }"
  [round]="rounded"
  [tuiSkeleton]="loading"
  (click)="onClick()"
></tui-avatar>
